module.exports = __webpack_public_path__ + "assets/img/38_441_big.29b79733.jpg";